(function () {
  'use strict';

  function initBenefitTabs() {
    var container = document.getElementById('c-benefit-tabs');
    if (!container) return;

    var tabs = Array.prototype.slice.call(container.querySelectorAll('.c-sg-tab'));
    var panels = Array.prototype.slice.call(container.querySelectorAll('.c-sg-tab-panel'));
    var indicators = Array.prototype.slice.call(container.querySelectorAll('.c-sg-tab-indicator'));

    function activateTab(idx) {
      tabs.forEach(function (tab, i) {
        var active = i === idx;
        tab.classList.toggle('c-sg-tab--active', active);
        tab.setAttribute('aria-expanded', active ? 'true' : 'false');
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('c-sg-tab-panel--active', i === idx);
      });
      indicators.forEach(function (indicator, i) {
        indicator.classList.toggle('c-sg-tab-indicator--active', i === idx);
      });
    }

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () {
        // One tab is always open — clicking the active tab does nothing
        if (tab.classList.contains('c-sg-tab--active')) return;

        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'benefit_tab_click' });
        activateTab(idx);
      });
    });

    // Auto-open first tab on page load
    activateTab(0);

    // benefit_tabs_view: fires once when the section is in the viewport for Var A.
    // The section is display:none until the Var A body class lands, so besides the
    // scroll observer we also re-check the moment that class is applied — otherwise
    // visitors who land with the section already in view can be missed.
    var viewFired = false;
    var observer = null;
    var classObserver = null;

    function isVarA() {
      return document.body.classList.contains('c-vDhPdp10VarA');
    }

    function fireView() {
      if (viewFired) return;
      viewFired = true;
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: 'benefit_tabs_view' });
      if (observer) observer.disconnect();
      if (classObserver) classObserver.disconnect();
      window.removeEventListener('scroll', checkInView);
      window.removeEventListener('resize', checkInView);
    }

    // Same rule as the observer: at least 10% of the section inside the viewport
    function checkInView() {
      if (viewFired || !isVarA()) return;
      var rect = container.getBoundingClientRect();
      if (!rect.height) return;
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(rect.bottom, viewportH) - Math.max(rect.top, 0);
      if (visible / rect.height >= 0.1) fireView();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && isVarA()) fireView();
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(container);
    }

    // Fallback alongside the observer; checkInView is a cheap no-op for Control
    window.addEventListener('scroll', checkInView, { passive: true });
    window.addEventListener('resize', checkInView);

    if (isVarA()) {
      checkInView();
      setTimeout(checkInView, 300);
    } else if ('MutationObserver' in window) {
      classObserver = new MutationObserver(function () {
        if (!isVarA()) return;
        classObserver.disconnect();
        // getBoundingClientRect forces layout, so the revealed section can be measured
        // right away; retry once in case late images/fonts shift it into view
        checkInView();
        setTimeout(checkInView, 300);
      });
      classObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitTabs);
  } else {
    initBenefitTabs();
  }
})();
